<template>
    <div class="box" :class="{leader:info.bu_identity_type==1}" @click="clerkInfo">
        <z-lazyImg :src="info.user_logo" class="box-left"></z-lazyImg>
        <div class="box-right">
            <div class="box-right-top">{{ info.real_name }}<span v-if="info.ticket_from_manager !== 0" class="point">&nbsp;</span></div>
            <div class="box-right-middle">
                <div class="box-right-middle-left">
                    <div>工号：{{ info.user_name }}</div>
                    <div>岗位：{{ info.position_name }}</div>
                    <div>年限：{{ info.work_date | workAge }}</div>
                </div>
                <div class="box-right-middle-right">
                    <div>身份：{{ info.bu_identity_type==1? "BU合伙人":"职员" }}</div>
                    <div>职级：{{ info.staffing_grade }}级</div>
                    <div>生日：{{ info.birth_date | justDate }}</div>
                </div>
                <div>入职时间：{{ info.work_date | justDate }}</div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">

    export default {
        props: ['info'],
        methods: {
            clerkInfo: function () {  
                this.$emit("click",this.info.id);
            }
        },
    }

</script>

<style lang="less" rel="stylesheet/less" scoped>
    .box {
        float: left;
        background: #ffffff;
        width: 300px;
        min-height: 150px;
        padding-bottom: 12px;
        margin-top: 20px;

        position: relative;
        font-size: 12px;
        color: #808080;
        cursor: pointer;
        transition:0.3s;
        &:hover{
            border-style: dashed !important;
        }
    }
    .point{
        display: inline-block;
        background-color: #ff6b6b;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        // transform: translateY(9px);
        vertical-align: middle;
        margin-left: 16px;
        margin-right: 5px;
    }

    .box-left {
        position: absolute;
        left: 16px;
        top: 12px;
        width: 60px;
        height: 60px;
        border-radius: 100%;
    }

    .box-right {
        margin-left: 90px;
        position:relative;
    }

    .box-right-top {
        height: 14px;
        font-size: 14px;
        line-height: 14px;
        margin-top: 12px;
        font-weight: bold;
    }

    .box-right-middle {
        margin-top: 10px;
        overflow: hidden;
        zoom: 1;
        line-height: 25px;
    }

    .box-right-middle-left,.box-right-middle-right{
        width: 50%;
    }

    .box-right-middle > div {
        float: left;
    }

    .box-right-middle p {
        height: 22px;
        line-height: 22px;
    }
</style>



// WEBPACK FOOTER //
// personBox.vue?5f29edaa